import React, { useRef, useState } from "react";
import logo from "../../asessts/Images/logo.png";
import loginImg from "../../asessts/Images/login_img.png";
import Api from "../../services/Api";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { fetchAndSetAdminData } from "../../services/AdminService";
function VerifyOtp() {
  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const [isLoading, setIsLoading] = useState(false);
  const credsString = localStorage.getItem("careCred");
  const creds = credsString ? JSON.parse(credsString) : null;
  const flowType = localStorage.getItem("flowType");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const otpInputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  const handleOtpChange = (index, value) => {
    const newOtpDigits = [...otpDigits];
    const customValue = value.substring(value.length - 1);
    newOtpDigits[index] = customValue;
    setOtpDigits(newOtpDigits);

    if (value === "" && index > 0) {
      otpInputRefs[index - 1].current.focus();
    } else if (value && index < otpInputRefs.length - 1) {
      otpInputRefs[index + 1].current.focus();
    }
  };

  const handleBackspaceOrClear = (e, index) => {
    if (e.key === "Backspace" || e.key === "Delete") {
      e.preventDefault();

      if (e.key === "Backspace" && index > 0) {
        otpInputRefs[index - 1].current.focus();
      }

      const newOtpDigits = [...otpDigits];
      newOtpDigits[index] = "";
      setOtpDigits(newOtpDigits);
    }
  };
  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    const otp = otpDigits.join("");
    if (otpDigits.some((digit) => !digit.trim())) {
      toast.error("OTP is required");
      return;
    }
    try {
      setIsLoading(true);
      const response = await Api.verifyOTP(creds.email, otp);
      const userId = response.data.data.id;
      const token = response.data.token;

      localStorage.setItem(
        "careCred",
        JSON.stringify({ email: creds.email, userId })
      );
      localStorage.setItem("careToken", token);
      localStorage.setItem("isVerified", "true");

      if (response.data.status) {
        toast.success("Successfully Verified Otp");
        if (flowType === "forgot-password") {
          localStorage.removeItem("isVerified");
          navigate("/change-password");
        } else {
          const token = localStorage.getItem("careToken");
          if (token) {
            await fetchAndSetAdminData(token, dispatch);
          }
          navigate("/dashboard");
        }
      } else {
        toast.error("Invalid Otp");
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error.response.data.message);
      setIsLoading(false);
    }
  };
  const resendOtp = async (e) => {
    e.preventDefault();

    try {
      const response = await Api.resendOTP(creds.email);
      console.log("response", response);

      if (response.data.status) {
        toast.success("Successfully Send Otp");
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  return (
    <div class="for-overlay">
      <section id="Dashboard-login-main">
        <div class="dashboard-input-left">
          <div class="logo">
            <a href="#">
              <img src={logo} alt="Logo" />
            </a>
          </div>
          <div className="login-input-details">
            <h2>Verifying Email</h2>
            <p>Please enter the OTP sent on your email</p>

            <form onSubmit={handleVerifyOTP}>
              <div className="otp-input">
                {otpDigits.map((digit, index) => (
                  <input
                    type="text"
                    id={`digit${index + 1}`}
                    pattern="[0-9]"
                    required
                    value={digit}
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    onKeyDown={(e) => handleBackspaceOrClear(e, index)}
                    ref={otpInputRefs[index]}
                    key={index}
                  />
                ))}
              </div>

              <div className="login-btn">
                <button type="submit" disabled={isLoading}>
                  {isLoading ? (
                    <div className="upload_loader mt-4"></div>
                  ) : (
                    "Verify OTP"
                  )}
                </button>
              </div>
            </form>

            <div className="resend-otp">
              <p>
                Didn't receive the email?{" "}
                <Link onClick={resendOtp}>Click to resend</Link>
              </p>
            </div>
          </div>
        </div>
        <div class="login-img-right">
          <img src={loginImg} alt="" />
        </div>
      </section>
    </div>
  );
}

export default VerifyOtp;
